import { render } from "./Sammelpunkte.vue?vue&type=template&id=cb166634"
import script from "./Sammelpunkte.vue?vue&type=script&lang=js"
export * from "./Sammelpunkte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__